import React, { useEffect, useState } from 'react'
import { Dialog } from 'components'
import { Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { getRoutePath } from 'routes/routes'

export default function ImportResultsDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    importresults = [],
    isImport = true,
    handleClose,
  } = _props
  const navigate = useNavigate()
  const [open, setOpen] = useState(true)
  const [isExport, setIsExport] = useState(!!importresults?.notOwnerList) // State to control the export button
  const [btnTitle, setBtnTitle] = useState('Administrar cuentas') // State to control the button title
  // State to control the submit action
  const [message, setMessage] = useState(
    'Estos son los resultados de la importación y asignación de CBUs'
  ) // State to control the message
  const [title, setTitle] = useState('Resultado de importación') // State to control the title
  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
    handleClose()
  }

  function handleSubmit() {
    navigate(getRoutePath('admin-cbu-accounts'))
  }

  function exportResults() {
    // if has notOwnerList export the array to txt file
    if (!importresults?.notOwnerList) return
    const element = document.createElement('a')
    const textData = importresults.notOwnerList
      .map((item) => {
        const cuit = `CUIT: ${item.cuit}`
        const cbu = `CBU: ${item.cbu}`
        const details = item.data
          .map((detail) => {
            return `Clave Tributaria: ${detail.ClaveTributaria}, Nombre: ${detail.Nombre}`
          })
          .join('\n')
        return `${cuit} - ${cbu} - ${details}\n`
      })
      .join('\n')
    const file = new Blob([textData], { type: 'text/plain;charset=utf-8' })
    element.href = URL.createObjectURL(file)
    element.download = 'NoTitulares.txt'
    document.body.appendChild(element) // Required for this to work in FireFox
    element.click()
    setIsExport(false)
  }
  useEffect(() => {
    setBtnTitle(isExport ? 'Exportar no titulares' : 'Administrar cuentas')
    setMessage(
      isExport
        ? 'Estos son los resultados de la importación y asignación de CBUs'
        : 'Estos son los resultados de asignación de CBUs'
    )
    setTitle(isExport ? 'Resultado de exportación' : 'Resultado de asignación')
  }, [isExport])
  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <Dialog
          open={open}
          handleClose={closeDialog}
          primaryButtonText={btnTitle} // Label of the primary button
          secondaryButtonText="Ok" // Label of the cancel button
          title={title} // 'Dialog title'
          message={message}
          onSubmit={{ isExport } ? exportResults : handleSubmit} // Form submit action
        >
          <div className="inline-block w-auto p-4 rounded-md border-2 border-primary">
            {isImport && (
              <Typography variant="body2" className="">
                <Typography variant="h3" component="span">
                  {`Total de CBUs importados correctament: ${importresults?.okImport} \n`}
                </Typography>
              </Typography>
            )}
            {importresults?.notOwnerList && (
              <Typography variant="body2" className="">
                <Typography variant="h3" component="span">
                  {`Cuentas no titulares: ${importresults?.notOwnerList.length} \n`}
                </Typography>
              </Typography>
            )}
            <Typography variant="body2" className="">
              <Typography variant="h3" component="span">
                {`Total de alumnos que no tenían CBU: ${importresults?.hadNotAccount} \n              `}
              </Typography>
            </Typography>
            <Typography variant="body2" className="">
              <Typography variant="h3" component="span">
                {`Total de procesados: ${importresults?.procesed} \n              `}
              </Typography>
            </Typography>
            <Typography variant="body2" className="">
              <Typography variant="h3" component="span">
                {`Total de asignados: ${importresults?.seted}`}
              </Typography>
            </Typography>
          </div>
        </Dialog>
      )}
    </>
  )
}
